var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cost-centre-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.selected.length === 0,
                    block: "",
                    color: "accent"
                  },
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                      _vm.selectedCostCentres = null
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("global.editSelected")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.users,
          search: _vm.search,
          "show-select": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: {
                          "hide-details": "",
                          primary: "",
                          value: props.isSelected
                        },
                        on: { change: props.select }
                      })
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.surname))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.login))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.email))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " + _vm._s(props.item.organization_structure) + " "
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openDialogDirectly(
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("settings.costCentre.user.dialogTitle")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.editedHeaders,
                      items: _vm.selected,
                      "hide-default-footer": "",
                      "footer-props": {
                        "items-per-page-options": [
                          {
                            text: "$vuetify.dataIterator.rowsPerPageAll",
                            value: -1
                          }
                        ]
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function(props) {
                          return [
                            _c("tr", [
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  _vm._s(props.item.name) +
                                    " " +
                                    _vm._s(props.item.surname)
                                )
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(_vm._s(props.item.login))
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(_vm._s(props.item.email))
                              ])
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("v-select", {
                    attrs: {
                      items: _vm.enabledCostCentres,
                      chips: "",
                      clearable: "",
                      "item-text": "name",
                      "item-value": "id",
                      label: _vm.$t(
                        "settings.costCentre.user.allowedCostCentres"
                      ),
                      multiple: ""
                    },
                    model: {
                      value: _vm.selectedCostCentres,
                      callback: function($$v) {
                        _vm.selectedCostCentres = $$v
                      },
                      expression: "selectedCostCentres"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      items: _vm.availableDefaultCostCentre,
                      clearable: "",
                      "item-text": "name",
                      "item-value": "id",
                      label: _vm.$t(
                        "settings.costCentre.user.defaultCostCentre"
                      )
                    },
                    model: {
                      value: _vm.defaultCostCentre,
                      callback: function($$v) {
                        _vm.defaultCostCentre = $$v
                      },
                      expression: "defaultCostCentre"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }